import Vue from "vue";
import Axios from "axios";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.setAnalytics();
        this.setHeader();
        this.setOpenMenu();
        this.setShareButton();
        this.setModal();
        this.setScrollTop();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader-box");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setAnalytics() {
        let gaEventItems = document.querySelectorAll("[data-gaevent=\"true\"]");
        if (gaEventItems && gaEventItems.length != 0) {
            for (let i = 0; i < gaEventItems.length; i++) {
                gaEventItems[i].addEventListener("click", function () {
                    const category = gaEventItems[i].getAttribute("data-gacategory");
                    switch (category) {
                        case "Visual":
                            GTagHelper.sendEvent("click", "visual", gaEventItems[i].getAttribute("href"));
                            break;
                        case "Highlight":
                            GTagHelper.sendEvent("click", "highlight", gaEventItems[i].getAttribute("href"));
                            break;
                        case "GoogleReview":
                            GTagHelper.sendEvent("click", "google_review");
                            break;
                        case "CtaHeader":
                            GTagHelper.sendEvent("click", "open_info_request", "header");
                            break;
                        case "CtaFooter":
                            GTagHelper.sendEvent("click", "open_info_request", "footer");
                            break;
                        case "Advantages":
                            GTagHelper.sendEvent("click", "open_info_request", "advantages");
                            break;
                        case "CtaWhatsApp":
                            GTagHelper.sendEvent("click", "whatsapp", "baloon");
                            break;
                    }
                });
            }
        }

        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }
    }

    private static setHeader() {
        let header = document.getElementById("Header");

        if (header) {
            if (window.scrollY > 0) {
                header.setAttribute("data-minify", "");
            }

            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-minify", "");
                } else {
                    header.removeAttribute("data-minify");
                }
            });
        }
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare"),
            shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }

    private static setOpenMenu() {
        let openMenu = document.getElementById("OpenMenu"),
            closeMenu = document.getElementById("CloseMenu"),
            wrapTap = document.getElementById("WrapTap"),
            header = document.getElementById("Header");

        if (openMenu) {
            openMenu.addEventListener("click", function () {
                wrapTap.setAttribute("data-show", "");
                header.setAttribute("data-show", "");
            });
        }

        if (wrapTap) {
            closeMenu.addEventListener("click", function () {
                wrapTap.removeAttribute("data-show");
                header.removeAttribute("data-show");
            });
        }
    }

    private static setModal() {
        let boxInfoRequest = document.getElementById("BoxInfoRequest");
        if (boxInfoRequest) {
            (<any>window).lightGallery(boxInfoRequest, {
                selector: "this",
                download: false,
                counter: false
            });
        }

        let headerInfoRequest = document.getElementById("HeaderInfoRequest");
        if (headerInfoRequest) {
            (<any>window).lightGallery(headerInfoRequest, {
                selector: "this",
                download: false,
                counter: false
            });
        }

        let footerInfoRequest = document.getElementById("FooterInfoRequest");
        if (footerInfoRequest) {
            (<any>window).lightGallery(footerInfoRequest, {
                selector: "this",
                download: false,
                counter: false
            });
        }

        let editorInfoRequest = document.getElementById("EditorInfoRequest");
        if (editorInfoRequest) {
            (<any>window).lightGallery(editorInfoRequest, {
                selector: "this",
                download: false,
                counter: false
            });
        }
    }

    private static setScrollTop() {
        let scrollTop = document.getElementById("ScrollTop");
        let whatsapp = document.getElementById("WhatsApp");

        if (scrollTop) {
            if (window.scrollY > 300) {
                scrollTop.setAttribute("data-minify", "");
            }

            window.addEventListener("scroll", function () {
                if (window.scrollY > 300) {
                    scrollTop.setAttribute("data-minify", "");
                } else {
                    scrollTop.removeAttribute("data-minify");
                }

                // End of page
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    scrollTop.setAttribute("data-endpage", "");
                    whatsapp.setAttribute("data-endpage", "");
                }
                else {
                    scrollTop.removeAttribute("data-endpage");
                    whatsapp.removeAttribute("data-endpage");
                }
            });
        }
    }
}